<template>
   <div>
      <customerFrom v-if="customerFromFlag" ref="customerFrom" @drawerCancel="initActionBox" :actionData="actionData1" @selectClick="selectClick"></customerFrom>
      <supplierFrom v-if="supplierFromFlag" ref="supplierFrom" @drawerCancel="initActionBox" :actionData="actionData1" @selectClick="selectClick"></supplierFrom>
      <goodsFrom v-if="goodsFromFlag" ref="goodsFrom" @drawerCancel="initActionBox" :actionData="actionData1" @selectClick="selectClick"></goodsFrom>
      <powerOfAttorney v-if="powerOfAttorneyFlag" ref="powerOfAttorney" @drawerCancel="initActionBox" :actionData="actionData1" @selectClick="selectClick"></powerOfAttorney>
   </div>
</template>

<script>
import customerFrom from './add/customerFrom.vue';//客户
import supplierFrom from './add/supplierFrom.vue';//供应商
import goodsFrom from './add/goodsFrom.vue';//商品
import powerOfAttorney from './add/powerOfAttorney.vue';//委托书
export default {
   props: ["actionData"],
   name: "materialAlteration",
   components: { customerFrom, supplierFrom, goodsFrom, powerOfAttorney },
   data() {
      return {
         customerFromFlag: false,//客户
         supplierFromFlag: false,//供应商
         goodsFromFlag: false,//商品
         powerOfAttorneyFlag: false,//委托书
         actionData1: {},
      }
   },
   methods: {
      openBox() {
         if (this.actionData.cate == 4 || this.actionData.type == 2) {
            this.getPageInfo(1614737190203)//客户
         } else if (this.actionData.cate == 5 || this.actionData.type == 1) {
            this.getPageInfo(1614737365602)//供应商
         } else if (this.actionData.cate == 8 || this.actionData.type == 3 || this.actionData.cate == 10) {//委托书
            if (this.actionData.type == 3) {
               this.actionData1 = {
                  cate: 1,
                  formData: [],
                  oldData: this.actionData.oldData1,
                  oldData1: "",
                  orderId: '',
                  printSouce: '',
                  printJurId: '',
               };
            } else {
               this.actionData1 = {
                  cate: 0,
                  formData: [],
                  oldData: "",
                  orderId: "",
                  printSouce: "",
                  printJurId: "",
                  type:this.actionData.cate == 8?"供应商":"客户"
               };
            }

            this.powerOfAttorneyFlag = true
         } else {
            this.getPageInfo(1614737096791)//商品
         }
      },
      // 获取数据列表
      async getPageInfo(val) {
         let responseData = await this.$http.getJur({
            ids: [val],
         });
         if (responseData.status == 200) {
            var arr = []
            responseData.result.jurFormVoList.forEach(item => {
               if (this.actionData.cate == 4 || this.actionData.type == 2) {//客户
                  if (item.jciId != 50020) {
                     arr.push(item)
                  }
               } else if (this.actionData.cate == 5 || this.actionData.type == 1) {//供应商
                  if (item.jciId != 50019) {
                     arr.push(item)
                  }
               } else if (this.actionData.cate == 6 || (this.actionData.type == 0 && this.actionData.oldData.goodType === 0)) {//商品-药品
                  if (item.jciId != 11149) {
                     if (!/(器|其他)/g.test(item.jciName)) arr.push(item);
                  }
               } else if (this.actionData.cate == 7 || (this.actionData.type == 0 && this.actionData.oldData.goodType === 1)) {//商品-器械
                  if (item.jciId != 11149) {
                     if (!/(商品|其他)/g.test(item.jciName)) arr.push(item);
                  }
               } else if (this.actionData.cate == 9 || (this.actionData.type == 0 && this.actionData.oldData.goodType === 2)) {//商品-其他
                  if (item.jciId != 11149) {
                     if (!/(商品|器)/g.test(item.jciName)) arr.push(item);
                  }
               }
            })
            this.formDataList = arr;
            if (this.actionData.cate == 4) {//客户
               this.actionData1 = {
                  cate: 0,
                  formData: this.formDataList,
                  oldData: "",
                  orderId: "",
                  printSouce: "",
                  printJurId: "",
               };
               this.customerFromFlag = true
            } else if (this.actionData.cate == 5) {//供应商
               this.actionData1 = {
                  cate: 0,
                  formData: this.formDataList,
                  oldData: '',
                  orderId: '',
                  printSouce: '',
                  printJurId: '',
               };
               this.supplierFromFlag = true
            } else if (this.actionData.cate == "修改-1") {
               this.actionData1 = {
                  cate: 1,
                  formData: this.formDataList,
                  oldData: this.actionData.oldData,
                  oldData1: this.actionData.oldData1,
                  orderId: '',
                  printSouce: '',
                  printJurId: '',
               };
               if (this.actionData.type == 2) {
                  this.customerFromFlag = true
               } else if (this.actionData.type == 1) {
                  this.supplierFromFlag = true
               } else if (this.actionData.type == 0) {
                  this.goodsFromFlag = true
               }
            } else {//商品
               this.actionData1 = {
                  cate: 0,
                  formData: this.formDataList,
                  oldData: '',
                  orderId: '',
                  printSouce: '',
                  printJurId: '',
               };
               this.goodsFromFlag = true
            }
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //取消新增
      initActionBox(val) {
         this.$emit("drawerCancel", val);
      },
      async selectClick(val) {
         var dataInfo = {}
         if (this.actionData.cate == 4) {//客户
            this.$http.queryCusmasterInfo({
               ids: [val]
            }).then(res => {
               if (res.status == 200) {
                  dataInfo = JSON.parse(JSON.stringify(res.result))
                  this.$set(dataInfo, 'oldlicencelinfos', JSON.parse(JSON.stringify(dataInfo.cuslicencelinfos)))
                  this.$set(dataInfo, 'newLicencelinfos', JSON.parse(JSON.stringify(dataInfo.cuslicencelinfos)))
                  this.$set(dataInfo, 'oldDescibCusAddress', JSON.parse(JSON.stringify(dataInfo.descibCusAddress||[])))
                  this.$set(dataInfo, 'newDescibCusAddress', JSON.parse(JSON.stringify(dataInfo.descibCusAddress||[])))
                  delete dataInfo.cuslicencelinfos //证照
                  delete dataInfo.descibCusAddressVos //地址
                  this.actionData1 = {
                     cate: 3,
                     formData: this.formDataList,
                     oldData: dataInfo,
                     orderId: dataInfo.gcmId,
                     printSouce: "",
                     printJurId: "",
                  };
                  this.$refs['customerFrom'].openBoxS()
               } else {
                  this.$message.error(res.message)
               }
            })
         } else if (this.actionData.cate == 5) {//供应商
            this.$http.querySupplierInfo({
               ids: [val]
            }).then(res => {
               if (res.status == 200) {
                  dataInfo = JSON.parse(JSON.stringify(res.result))
                  this.$set(dataInfo, 'newLicencelinfos', JSON.parse(JSON.stringify(dataInfo.suplicencelinfos)))
                  this.actionData1 = {
                     cate: 3,
                     formData: this.formDataList,
                     oldData: dataInfo,
                     orderId: dataInfo.gsmId,
                     printSouce: '',
                     printJurId: '',
                  }
                  this.$refs['supplierFrom'].openBoxS()
               } else {
                  this.$message.error(res.message)
               }
            })
         } else {//商品-药品
            this.$http.getBusinessGoodsDetails({
               ids: [val]
            }).then(res => {
               if (res.status == 200) {
                  dataInfo = JSON.parse(JSON.stringify(res.result))
                  this.$set(dataInfo, 'newGoodLicenceAddList', JSON.parse(JSON.stringify(dataInfo.descibGoodLicenceAddList)))
                  this.actionData1 = {
                     cate: 3,
                     formData: this.formDataList,
                     oldData: dataInfo,
                     orderId: dataInfo.ggmId,
                     printSouce: '',
                     printJurId: '',
                  }
                  this.$refs['goodsFrom'].openBoxS()
               } else {
                  this.$message.error(res.message)
               }
            })
         }

      }
   },
   created() {
      this.$nextTick(() => {
         this.openBox()
      });
   }
}
</script>

<style>
</style>